import { createContext, useContext, useReducer } from "react";

export const ChooseGoodsStore = createContext<IContextProps>(null);

interface IContextProps {
  state: IState;
  dispatch: ({ type }: Dispatch) => void;
}

type Dispatch = { type; payload };

class Search {
  keywords: string;
  classesId: string;
  statusId: string;
}

interface IState {
  search: Search;
  diff: number;
  dataList: any[];
}

const initialArgs = {
  diff: 0,
  dataList: [],

  search: new Search(),
};

function reducer(state: IState, { type, payload }: Dispatch) {
  switch (type) {
    case "SetList":
      return {
        ...state,
        dataList: payload,
      };
    case "SetSearch":
      return {
        ...state,
        search: {
          ...state.search,
          ...payload,
        },
      };
    case "SetAreaList":
      return {
        ...state,
        areaList: payload,
      };
    case "Diff":
      let num = state.diff + payload;
      state.diff = num;
      return {
        ...state,
      };
    default:
      return state;
  }
}

export function ChooseStoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialArgs);

  const v = { state, dispatch };
  return (
    <ChooseGoodsStore.Provider value={v}>
      {props.children}
    </ChooseGoodsStore.Provider>
  );
}
